import { connect } from 'react-redux';
import { find, get } from 'lodash';
import DepositPayment from '../../components/commit-form/deposit-payment';
import { COMMIT_NAMESPACE } from '../../actions';
import money from '../../lib/money';

const mapStateToProps = (state) => {
  const purchase = get(state.projections, `${COMMIT_NAMESPACE}.purchase`);
  if (!purchase) return {};
  const deposit = find(purchase.payments, payment => payment.number === 1);
  return {
    depositAmount: money(get(deposit, 'amount')),
  };
};

export default connect(mapStateToProps)(DepositPayment);



// WEBPACK FOOTER //
// ./src/desktop/containers/organizer-commit/deposit-payment.container.js